const setRewardSystemHistoryData = payload => ({
  type: "SET_REWARD_SYSTEM_HISTORY_DATA",
  payload
});

const setRedemptionData = payload => ({
  type: "SET_REDEMPTION_DATA",
  payload
});

const setRedemptionGraphData = payload => ({
  type: "SET_REDEMPTION_GRAPH DATA",
  payload
});

const setRewardHistoryResult = payload => ({
  type: "SET_REWARD_HISTORY_RESULT",
  payload
});

export default {
  setRewardSystemHistoryData,
  setRedemptionData,
  setRedemptionGraphData,
  setRewardHistoryResult
};
